import { Permission } from '@/lib/permissions/v1'

export enum CompanySettingsRoute {
    Index = 'company.settings.index',
}

export default {
    path: 'settings',
    name: CompanySettingsRoute.Index,
    component: () => import('@/views/company/settings/Index.vue'),
    meta: {
        label: 'Settings',
        auth: true,
        permission: Permission.CompanyUpdate,
    },
    children: [],
}
